import { getAuth } from "firebase/auth";
import { child, get, getDatabase, ref, update } from "firebase/database";
import "../Firebase";

const auth = getAuth();

let db = getDatabase();
const dbRef = ref(getDatabase());
const teamsRef = ref(db, "teams");

export const myCompanyIntro = async () => {
  let user = (await get(child(dbRef, `users/${auth.currentUser.uid}`))).val();
  if (!user) return null;
  let introDataSnap = await get(child(teamsRef, `${user.teamId}/IntroData`));
  let introData = introDataSnap.val();
  if (!introData) return null;
  return introData;
};

export const saveIntro = async (introData) => {
  get(child(dbRef, `users/${auth.currentUser.uid}`))
    .then((snap) => {
      let user = snap.val();
      if (!(user && introData)) return null;
      update(child(dbRef, `teams/${user.teamId}`), { IntroData: introData });
    })
    .catch(console.log);
  return true;
};

export const getCompanyIntro = async (teamId) => {
  let introDataSnap = await get(child(teamsRef, `${teamId}/IntroData`));
  let introData = introDataSnap.val();
  if (!introData) return null;
  return introData;
};
